import styled, { css } from 'styled-components';

const activeChipStyle = css`
	background-color: #EBF0FF;
	border: 1px solid #5B7FFF;
	color: #5B7FFF;
`;

const inactiveChipStyle = css`
	background-color: #FFFFFF;
	border: 1px solid #D9E1E8;
	color: #26282A;
`;

export const SignaturePadContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Chip = styled.div`
	border-radius: 9999px;
	${props => props.active ? activeChipStyle : inactiveChipStyle}
`;

export const CanvasWrapper = styled.div`
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	overflow: hidden;

	.sigCanvas {
		width: 100% !important;
		height: 100% !important;
	}
`;

export const InputContainer = styled.div`
	width: 100%;
	height: 214px;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	position: relative;
	margin-bottom: 6px;
`;

export const TextArea = styled.textarea`
	height: 211px;
	line-height: normal !important;
	color: #000 !important;
	border: none;
	border-radius: 8px;
	text-align: center;
	font-family: Ephesis !important;
	font-size: 35px !important;
	font-style: normal;
	font-weight: 550;
	resize: none !important;
	padding: 8px !important;
`;

export const Actions = styled.div`
	display: flex;
	justify-content: flex-start;
	margin-top: 8px;
`;
